// extracted by mini-css-extract-plugin
export default {"boosterContainer":"ShowBoosters_boosterContainer__89+h2","boosterWidth":"ShowBoosters_boosterWidth__bqErB"};